export {default} from './CloseToRankReportContent';
